import React, { Dispatch, SetStateAction } from 'react';
import Router from 'next/router';

// GA
import { gaEvent, gaVisitPage } from '@components/utils/analytics';
import * as Sentry from '@sentry/nextjs';

// Providers
import { useAuth } from '@/providers/Auth';

// Components
import Menu from '@components/UI-KIT/Menu';
import MenuItem from '@components/UI-KIT/Menu/MenuItem';
import Divider from '@components/UI-KIT/Divider';
import Footer from '@components/UI-KIT/Footer';
import { useOrganization } from '@lib/layout/main';

// Icons
import {
    Document,
    Building,
    Key,
    Wallet,
    Settlement,
    Checklist,
    Person,
    CheckStar,
    Leave
} from '@/assets/icons';

interface Props {
    expanded: boolean,
    setExpanded: Dispatch<SetStateAction<boolean>>
}

const ListItems: React.FC<Props> = ({ expanded, setExpanded }) => {
    const { setLogout } = useAuth();

    const { organization } = useOrganization();

    return (
        <Menu
            expanded={expanded}
            setExpanded={setExpanded}
        >
            <MenuItem
                href="/cuentas"
                icon={Wallet}
                onClick={() => gaVisitPage('/cuentas')}
                label="Cuentas"
            />
            <Divider />
            <MenuItem
                href="/contratos/listado"
                icon={Document}
                onClick={() => gaVisitPage('/contratos/listado')}
                label="Contratos"
            />
            <MenuItem
                icon={Checklist}
                label="Cobrar a inquilino"
                href="/alquileres/listado"
                onClick={() => gaVisitPage('/alquileres/listado')}
            />
            <MenuItem
                icon={Settlement}
                label="Pagar a propietario"
                href="/liquidaciones/listado"
                onClick={() => gaVisitPage('/liquidaciones/listado')}
            />
            <Divider />
            <MenuItem
                href="/propietarios/listado"
                icon={Key}
                onClick={() => gaVisitPage('/propietors')}
                label="Propietarios"
            />
            <MenuItem
                href="/propiedades/listado"
                icon={Building}
                onClick={() => gaVisitPage('/propiedades/listado')}
                label="Propiedades"
            />
            <MenuItem
                href="/inquilinos/listado"
                icon={Person}
                onClick={() => gaVisitPage('/inquilinos/listado')}
                label="Inquilinos"
            />
            <MenuItem
                href="/garantes/listado"
                icon={CheckStar}
                onClick={() => gaVisitPage('/garentes/listado')}
                label="Garantes"
            />
            <Divider />
            <Footer
                className="ui-Menu-footer"
            >
                {/* <MenuItem
                    href="#"
                    onClick={console.log}
                    label="Mi cuenta"
                /> */}
                <MenuItem
                    href="/session"
                    onClick={() => {
                        setLogout();
                        gaEvent('Button', 'End session', 'Pressed "cerrar sesion" button on left menu panel');
                        Sentry.setUser(null);
                        Sentry.setContext('', null);
                        Router.replace('/session');
                    }}
                    label={`${organization ? `${organization.name} - ` : ''}Salir`}
                    icon={Leave}
                />
            </Footer>
        </Menu>
    );
};

export default ListItems;
